class SingleProduct {
  constructor() {
    this.compositionMaillotButton = document.querySelector(
      '.composition-maillot-title'
    );
    this.compositionMaillotContent = document.querySelector(
      '.composition-maillot-content'
    );
    this.compositionMaillotTrigger = document.querySelector(
      '.composition-maillot-trigger'
    );
    this.livraisonMaillotButton = document.querySelector(
      '.livraison-maillot-title'
    );
    this.livraisonMaillotContent = document.querySelector(
      '.livraison-maillot-content'
    );
    this.livraisonMaillotTrigger = document.querySelector(
      '.livraison-maillot-trigger'
    );
    this.tailleButtons = document.querySelectorAll('.taille-attribute-button');
    this.addToCartButton = document.querySelector('#add_to_cart_button');
    this.selectSizeWarning = document.querySelector('.select-size-warning');
    this.addToCartButtonContainer = document.querySelector(
      '.add-to-cart-button-container'
    );
    this.singleProductContent = document.querySelector(
      '#single-product-content'
    );
    this.singleProductSizeGuide = document.querySelector(
      '#single-product-size-guide'
    );
    this.closeSizeGuideButton = document.querySelector('#close-size-guide');
    this.displaySizeGuideButton = document.querySelector(
      '#display-size-guide-button'
    );
    this.miniCartIcon = document.querySelector('#mini-cart-icon');
    this.events();
  }

  events() {
    this.compositionMaillotClicked();
    this.livraisonMaillotClicked();
    this.tailleButtonClicked();
    this.disabledAddToCartButtonClicked();
    this.sizeGuideDisplayListener();
  }

  sizeGuideDisplayListener() {
    if (
      this.closeSizeGuideButton &&
      this.singleProductSizeGuide &&
      this.singleProductContent
    ) {
      this.closeSizeGuideButton.addEventListener('click', (e) => {
        this.singleProductSizeGuide.classList.add('hidden');
        this.singleProductContent.classList.remove('hidden');
      });
      this.displaySizeGuideButton.addEventListener('click', (e) => {
        this.singleProductSizeGuide.classList.remove('hidden');
        this.singleProductContent.classList.add('hidden');
        window.scrollTo(0, 0);
      });
    }
  }

  compositionMaillotClicked() {
    if (
      this.compositionMaillotButton &&
      this.compositionMaillotContent &&
      this.compositionMaillotTrigger
    ) {
      this.compositionMaillotButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.compositionMaillotContent.classList.contains('hidden')
          ? this.compositionMaillotContent.classList.remove('hidden')
          : this.compositionMaillotContent.classList.add('hidden');
        this.compositionMaillotContent.classList.contains('hidden')
          ? (this.compositionMaillotTrigger.innerHTML = '+')
          : (this.compositionMaillotTrigger.innerHTML = '-');
      });
    }
  }

  livraisonMaillotClicked() {
    if (
      this.livraisonMaillotButton &&
      this.livraisonMaillotContent &&
      this.livraisonMaillotTrigger
    ) {
      this.livraisonMaillotButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.livraisonMaillotContent.classList.contains('hidden')
          ? this.livraisonMaillotContent.classList.remove('hidden')
          : this.livraisonMaillotContent.classList.add('hidden');
        this.livraisonMaillotContent.classList.contains('hidden')
          ? (this.livraisonMaillotTrigger.innerHTML = '+')
          : (this.livraisonMaillotTrigger.innerHTML = '-');
      });
    }
  }

  tailleButtonClicked() {
    if (this.tailleButtons) {
      this.tailleButtons.forEach((tailleButton) => {
        tailleButton.addEventListener('click', (e) => {
          // console.log('clicked');
          if (tailleButton.getAttribute('data-selected')) {
            console.log(tailleButton.getAttribute('data-selected'));
            if (tailleButton.getAttribute('data-selected') == 'true') {
              this.enableAddToCartButton();
            } else {
              this.disableAddToCartButton();
            }
          }
        });
      });
    }
  }

  enableAddToCartButton() {
    if (
      this.addToCartButton &&
      this.selectSizeWarning &&
      this.addToCartButtonContainer
    ) {
      this.selectSizeWarning.classList.add('hidden');
      this.addToCartButtonContainer.classList.remove('cursor-default');
      this.addToCartButtonContainer.classList.add('cursor-pointer');
      this.addToCartButtonContainer.classList.add('hidden');
      this.addToCartButton.classList.remove('opacity-30');
      this.addToCartButton.disabled = false;
    }
  }

  disableAddToCartButton() {
    if (
      this.addToCartButton &&
      this.selectSizeWarning &&
      this.addToCartButtonContainer
    ) {
      this.selectSizeWarning.classList.add('hidden');
      this.addToCartButtonContainer.classList.add('cursor-default');
      this.addToCartButtonContainer.classList.remove('cursor-pointer');
      this.addToCartButtonContainer.classList.remove('hidden');
      this.addToCartButton.classList.add('opacity-30');
      this.addToCartButton.disabled = true;
    }
  }

  disabledAddToCartButtonClicked() {
    if (
      this.addToCartButton &&
      this.selectSizeWarning &&
      this.addToCartButtonContainer
    ) {
      if (this.addToCartButton.disabled) {
        this.addToCartButtonContainer.addEventListener('click', (e) => {
          this.selectSizeWarning.classList.remove('hidden');
        });
      }
    }
  }
}

export default SingleProduct;
